import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutTags } from './types.esm.js';
var UitkLayout = function (props) {
  var children = props.children,
    className = props.className,
    tag = props.tag,
    domRef = props.domRef,
    attributes = __rest(props, ["children", "className", "tag", "domRef"]);
  // Renders the custom Tag
  var Tag = tag && UitkLayoutTags.get(tag) || UitkLayoutTags.get('div');
  return children ? React.createElement(Tag, __assign({
    ref: domRef,
    className: className
  }, attributes), children) : null;
};
export { UitkLayout };